import changePasswordSVG from '../img/change-password.svg';
import disableSVG from '../img/disable.svg';
import editSVG from '../img/edit.svg';
import informationsSVG from '../img/informations.svg';
import lastMovementsSVG from '../img/last-movements.svg';
import changePermissionsSVG from '../img/change-permissions.svg';

export const actionItems = {
  forEnabled: [
    {
      svg: changePasswordSVG,
      title: 'changePassword',
    },
    {
      svg: lastMovementsSVG,
      title: 'lastMovements',
    },
    {
      svg: changePermissionsSVG,
      title: 'changePermissions',
    },
    {
      svg: disableSVG,
      title: 'disable',
    },
    {
      svg: editSVG,
      title: 'edit',
    },
    {
      svg: informationsSVG,
      title: 'informations',
    },
  ],
  forDisabled: [
    {
      svg: disableSVG,
      title: 'enable',
    },
  ],
};

export const getActionItems = ({ role, isBanned }) => {
  if (isBanned) {
    return [
      {
        svg: disableSVG,
        title: 'enable',
      },
    ];
  }
  if (+role === 0) {
    return [
      {
        svg: changePasswordSVG,
        title: 'changePassword',
      },
      {
        svg: lastMovementsSVG,
        title: 'lastMovements',
      },
      {
        svg: disableSVG,
        title: 'disable',
      },
      {
        svg: changePermissionsSVG,
        title: 'changePermissions',
      },
      {
        svg: informationsSVG,
        title: 'informations',
      },
    ];
  }
  if (+role === 6) {
    return [
      {
        svg: changePasswordSVG,
        title: 'changePassword',
      },
      {
        svg: lastMovementsSVG,
        title: 'lastMovements',
      },
      {
        svg: disableSVG,
        title: 'disable',
      },
      {
        svg: changePermissionsSVG,
        title: 'changePermissions',
      },
      {
        svg: editSVG,
        title: 'edit',
      },
      {
        svg: informationsSVG,
        title: 'informations',
      },
    ];
  }
};

export const permissionsDetailsData = [
  {
    category: 'casino',
    items: [
      'evoplay',
      'slotegrator',
      'softgaming-slots',
      'outcome',
      'fiable',
      'rubiplay',
      'bswgames',
      'flg',
      'pragmatic',
      'inbet',
    ],
  },
  {
    category: 'liveCasino',
    items: ['tvbet', 'xpg', 'ezugi'],
  },
  { category: 'sport', items: ['Digitain'] },
];
